import '../styles/solutions.css';
import { useNavigate } from 'react-router-dom';

function Solutions() {
    const navigate = useNavigate();

    return (
        <div className="solutions-page">
            <section className="container solutions-header">
                <h1>Solutions for Every Rental Business</h1>
                <p>Fleetify adapts to your unique business model - whether you're managing cars, vans, trucks, or specialty vehicles.</p>
            </section>

            <section className="solutions-grid container">
                <div className="solution-card">
                    <h2>Airport Rentals</h2>
                    <p>Streamline bookings, manage quick turnarounds, and offer seamless pickup/drop-off experiences for busy travelers.</p>
                </div>
                <div className="solution-card">
                    <h2>City Rentals</h2>
                    <p>Maximize fleet usage and automate pricing for peak hours, urban events, and weekend surges.</p>
                </div>
                <div className="solution-card">
                    <h2>Luxury & Exotic Rentals</h2>
                    <p>Track premium vehicles, enforce security deposits, and provide high-end customer service workflows.</p>
                </div>
                <div className="solution-card">
                    <h2>Fleet Operators</h2>
                    <p>Manage dozens to hundreds of vehicles, maintenance schedules, co-hosts, and long-term leases with ease.</p>
                </div>
            </section>

            <section className="solutions-cta">
                <div className="container">
                    <h2>Find the Right Fit for Your Business</h2>
                    <p>Fleetify’s solutions are built to scale and flex. Tell us your needs - we’ll handle the complexity.</p>
                    <button
                        className="btn btn-primary"
                        onClick={() => navigate('/sales')}
                    >
                        Talk to Sales
                    </button>
                </div>
            </section>
        </div>
    );
}

export default Solutions;
